export const PADDING_SIZES_WITH_NONE = [
  { value: 'none', label: 'None' },
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export const PADDING_SIZES = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export const TABLE_ITEMS_PER_PAGE = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 250, label: '250' },
  { value: 500, label: '500' },
];

export const GRID_ITEMS_PER_PAGE = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 250, label: '250' },
  { value: 500, label: '500' },
];

export const GRID_ITEM_IMAGE_MODES = [
  { value: 'thumbnail', label: 'Thumbnail' },
  { value: 'gallery', label: 'Gallery' },
];

export const FONTS = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Barlow', label: 'Barlow' },
  { value: 'Figtree', label: 'Figtree' },
  { value: 'Karla', label: 'Karla' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Mulish', label: 'Mulish' },
  { value: 'Nunito Sans', label: 'Nunito Sans' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Rubik', label: 'Rubik' },
  { value: 'Work Sans', label: 'Work Sans' },
];

export const FONT_SIZES = [
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 14, label: '14' },
  { value: 16, label: '16' },
  { value: 18, label: '18' },
];

export const TEXT_ALIGNMENTS = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
];

export const DATE_FORMATS = [
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
];

export const TIME_FORMATS = [
  { value: '24h', label: '24h' },
  { value: '12h', label: '12h' },
];
